module.exports = __webpack_public_path__ + "media/images/scansoles-logo-big-36168b89c8d71b136e5fbe9585458ed8.png";